
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _126pdpaa0gwEGNQq2I9Eg32ZIpt3kDaTK4QMRi_WMkNF_9tH8Meta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/~pdp.vue?macro=true";
import { default as cartJEmJ2p9l_SLA6vVDZG9foe36yOisvxIXZI1Lj5Ev8XEMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/cart.vue?macro=true";
import { default as index5Daq__ENa9a_im7EItTDyZZx2pR52xG2vsSnSJpt08QMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/pages/index.vue?macro=true";
import { default as searchCzMbIRsErhwU_7ntXxPVblxBwCR6euS0bm5ZoVbKvc4Meta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/pages/search.vue?macro=true";
import { default as editIUUtiFhEbTMlXpDchK4cKf63kJuOaAQ979c6_JDgFRcMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/edit.vue?macro=true";
import { default as index8oQEIqMF8MPW6x93imytQ8QRiagPaKDamd0QHi8qU88Meta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/account/index.vue?macro=true";
import { default as newsletteroBKQG_TskuCWpo_op_vmQE0ZZTNPABCtl7ZJbJsnmewMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/newsletter.vue?macro=true";
import { default as _91id_93D2nykv94ioNgfPPSPbZQ7wBRYeKYKo23HOjewYuLgmgMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/account/orders/[id].vue?macro=true";
import { default as indexf5IpeFulO05HaC2QQX13R6c9bxwtIWID35J0Lwr64sgMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/account/orders/index.vue?macro=true";
import { default as indexfzxIn4XOY2WN9cMuJ0wkcmfmNA66K52ERa49KAZEI9kMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/index.vue?macro=true";
import { default as createWAGOTE0KfFyEQ8SnVr8A3zfPioE7c6rkI48w_8WkdYQMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/create.vue?macro=true";
import { default as _91id_93CnjGkBhlXxGZzQvOFP8feegd9tY_ldV0tamn3YmuQqcMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/edit/[id].vue?macro=true";
import { default as accountl3U4ge6BB9Q4Jgve6UzB01IG_1VDLrYM0c3IGrmNRcwMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/account.vue?macro=true";
import { default as paymentXan9E__dO9mTslym4jg_sup4bKZSJyEDiOfBs4GLeOMMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/pages/payment.vue?macro=true";
import { default as successm2KVUpjyjmc8Y_f764gjTBbDF_9uQj_FHu007oaocOEMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/pages/success.vue?macro=true";
import { default as indexaO7icN6KmageNX4QTYIrGMmbk7WotCNeWARqooXasVsMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/checkout/index.vue?macro=true";
import { default as paymentww8enh7dmlAAyVIdKNTUneXhDRSUtPEw3yS6QIt4e7QMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/checkout/payment.vue?macro=true";
import { default as shipment0rnG_l6Y05XrR7WGy68K8S9f96PssXPRnotg5VkrZoMMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/checkout/shipment.vue?macro=true";
import { default as checkoutyH5MrmDvqqyne2vqigON0oLATBx3GrN9i1GDoZb6iEAMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/checkout.vue?macro=true";
import { default as customerw0bSH184jg_U2Ye0BhOilT7WpPeplfVESUqT3vZWj8EMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/pages/customer.vue?macro=true";
import { default as registerPiS6xQzDFt3IdRFDKg2AYDOVP1to3PHJvFqo9wqXgzYMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/register.vue?macro=true";
import { default as wishlist5N8rBZQYWrQaNc__Cgl8XBKrNCFEWK9paP06LzlD6WcMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93_HYwDN3dsTry6TtwrUnQtQQPbEV5Ldn8SSyGPzuv_n8Meta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/[...slug].vue?macro=true";
import { default as empty_45layoutZwu4IGW8rIgM512LAb7TLZudUaQenwwO7I7W6Uye4XcMeta } from "/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/pages/empty-layout.vue?macro=true";
import { default as reset_45passwordBM__eTClfIE8w5_useUcdIQlAwPM8bl8_duoEL4yzHYMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordF4hSU5sdV4V_GiNDErenu9d6gZ_x9uVRwQa2AR_U0SQMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/forgot-password.vue?macro=true";
import { default as headingsCvb1RyZkC9M9NKn0eEZ51B7Onl_r3I_gtdeZDLLqJMsMeta } from "/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/design-system/element-styles/headings.vue?macro=true";
export default [
  {
    name: "~pdp",
    path: "/~pdp",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/~pdp.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/cart.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/pages/search.vue")
  },
  {
    name: accountl3U4ge6BB9Q4Jgve6UzB01IG_1VDLrYM0c3IGrmNRcwMeta?.name,
    path: "/account",
    meta: accountl3U4ge6BB9Q4Jgve6UzB01IG_1VDLrYM0c3IGrmNRcwMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/account.vue"),
    children: [
  {
    name: "account-edit",
    path: "edit",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/edit.vue")
  },
  {
    name: "account",
    path: "",
    meta: index8oQEIqMF8MPW6x93imytQ8QRiagPaKDamd0QHi8qU88Meta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/account/index.vue")
  },
  {
    name: "account-newsletter",
    path: "newsletter",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/newsletter.vue")
  },
  {
    name: "account-orders-id",
    path: "orders/:id()",
    meta: _91id_93D2nykv94ioNgfPPSPbZQ7wBRYeKYKo23HOjewYuLgmgMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders",
    path: "orders",
    meta: indexf5IpeFulO05HaC2QQX13R6c9bxwtIWID35J0Lwr64sgMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/account/orders/index.vue")
  },
  {
    name: "account-addresses",
    path: "addresses",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/index.vue")
  },
  {
    name: "account-addresses-create",
    path: "addresses/create",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/create.vue")
  },
  {
    name: "account-addresses-edit-id",
    path: "addresses/edit/:id()",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/edit/[id].vue")
  }
]
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/pages/payment.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/pages/success.vue")
  },
  {
    name: checkoutyH5MrmDvqqyne2vqigON0oLATBx3GrN9i1GDoZb6iEAMeta?.name,
    path: "/checkout",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/checkout.vue"),
    children: [
  {
    name: "checkout",
    path: "",
    meta: indexaO7icN6KmageNX4QTYIrGMmbk7WotCNeWARqooXasVsMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment",
    path: "payment",
    meta: paymentww8enh7dmlAAyVIdKNTUneXhDRSUtPEw3yS6QIt4e7QMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/checkout/payment.vue")
  },
  {
    name: "checkout-shipment",
    path: "shipment",
    meta: shipment0rnG_l6Y05XrR7WGy68K8S9f96PssXPRnotg5VkrZoMMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/checkout/shipment.vue")
  }
]
  },
  {
    name: "customer",
    path: "/customer",
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/pages/customer.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerPiS6xQzDFt3IdRFDKg2AYDOVP1to3PHJvFqo9wqXgzYMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/register.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/wishlist.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/[...slug].vue")
  },
  {
    name: "empty-layout",
    path: "/empty-layout",
    meta: empty_45layoutZwu4IGW8rIgM512LAb7TLZudUaQenwwO7I7W6Uye4XcMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/pages/empty-layout.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordBM__eTClfIE8w5_useUcdIQlAwPM8bl8_duoEL4yzHYMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordF4hSU5sdV4V_GiNDErenu9d6gZ_x9uVRwQa2AR_U0SQMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/forgot-password.vue")
  },
  {
    name: "design-system-element-styles-headings",
    path: "/design-system/element-styles/headings",
    meta: headingsCvb1RyZkC9M9NKn0eEZ51B7Onl_r3I_gtdeZDLLqJMsMeta || {},
    component: () => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/pages/design-system/element-styles/headings.vue")
  }
]